import {getRoundLimit} from "../../checkIfFinalRound";

/**
 * Успеет ли отряд поплатиться за то, что стоит вне зоны снабжения.
 *
 * Штраф (−2 размера, при Варварстве −1) списывается по завершении ФАЗЫ
 * СНАБЖЕНИЯ, а она открывает раунд (ROUND_PHASES = [SUPPLY, CONSTRUCTION,
 * WAR]). Значит отряду, оказавшемуся вне снабжения в фазе войны раунда N,
 * платить в раунде N + 1. В финальном раунде такого раунда уже не будет:
 * партия заканчивается сразу после фазы войны, отряд доживет до подсчета
 * очков в любом случае.
 *
 * Нужно подсказкам, которые показываются в ФАЗЕ ВОЙНЫ (перемещение, маневр,
 * найм на казарме) — см. GameScene.showSupplyOutOfRangeHintIfNeeded: в
 * финальном раунде такая подсказка была бы ложной тревогой.
 *
 * Досрочный конец партии по отрыву в очках (hasDominantPlayer) здесь не
 * учитывается сознательно: в момент подсказки он еще не наступил и наступит
 * ли — неизвестно.
 *
 * @param {number} round - текущий раунд
 * @param {number|null} finalRound - финальный раунд партии (у локальных игр и
 *   миссий задается отдельно, поэтому берется из состояния, а не из конфига);
 *   null — раунды не ограничены, штраф впереди всегда
 */
export const checkIfOutOfSupplyPenaltyAhead = (round, finalRound) => {
  const roundLimit = getRoundLimit(finalRound);
  return roundLimit === null || round < roundLimit;
};
